<!-- 裁剪头像组件 -->
<template>
  <el-dialog :visible.sync="value" title="裁剪头像" width="500px" :before-close="handleClose">
    <div class="w-full h-[300px]">
      <vueCropper
        ref="cropper"
        :img="cropperUrl"
        :outputSize="1"
        outputType="jpg"
        :autoCrop="true"
        :centerBox="true"
        :original="false"
        :fixed="true"
        :fixedNumber="[1, 1]"
        mode="cover"
      ></vueCropper>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="getCropper">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper';
import { EventBus } from '@/utils/eventbus';

export default {
  name: 'AvatarCropper',
  components: {
    VueCropper,
  },
  props: {
    // 传入的图片地址
    cropperUrl: {
      type: String,
      default: '',
    },
    // 是否显示
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('update-visible', !this.value);
    },
    // 获取裁剪后的图片
    getCropper() {
      this.$refs.cropper.getCropBlob((data) => {
        let file = new File([data], 'avatar.jpg', { type: 'image/jpeg' });
        EventBus.$emit('upload:cropper', file);
        this.handleClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
